/**
 * CTRIP-P1 · 携程对照表 + 携程资料 API · 真契约源 apps/api-server/src/api_server/routes/ctrip_lookups.py
 * 样稿 designs/mockups/channel-center/携程价库直连-样稿.html ④⑤，接口表 API_MAP-携程价库直连.md。
 */
import { api } from "./api";

export type LookupKind = "city" | "poi" | "hotel";
export type LookupStatus = "pending" | "matched" | "not_on_ctrip";

export const LOOKUP_KIND_LABEL: Record<LookupKind, string> = { city: "城市", poi: "景点", hotel: "酒店" };

export interface LookupItem {
  our_id: string;
  kind: LookupKind;
  name_cn: string | null;
  name_en: string | null;
  ctrip_id: number | null;
  not_on_ctrip: boolean;
  status: LookupStatus;
  /** 用到它的（已勾携程的多日游）产品个数 */
  used_by_count: number;
}

export interface LookupList {
  kind: LookupKind;
  counts: Record<LookupStatus, number>;
  items: LookupItem[];
}

export interface LookupSummary {
  city: KindSummary;
  poi: KindSummary;
  hotel: KindSummary;
  pending_total: number;
}
interface KindSummary { pending: number; matched: number; not_on_ctrip: number; total: number }

export interface Candidate {
  ctrip_id: number;
  name: string | null;
  full_name: string | null;
  extra: { type?: string; rooms?: (string | null)[] } | null;
}
export interface CandidateResult { kind: LookupKind; our_id: string; keyword: string; candidates: Candidate[] }

export interface LookupSaved { kind: LookupKind; our_id: string; ctrip_id: number | null; not_on_ctrip: boolean; status: LookupStatus; stale_listings: number }

export interface Contact { name: string | null; mobile: string | null }
export interface CtripProfile {
  contract_id: number | null;
  brand_name: string | null;
  complain_contact: Contact;
  booking_contact: Contact;
  child: { bookable: boolean | null; age_min: number | null; age_max: number | null };
  tour_type: string | null;
  product_type: string | null;
  /** AddProductInfo.nameRuleList：国家 / 省份 / 景区的携程 ID，人工填，可多条 */
  name_rules: { type: NameRuleType; ctrip_id: number }[];
}
export type NameRuleType = "country" | "province" | "scenic";
export const NAME_RULE_LABEL: Record<NameRuleType, string> = { country: "国家", province: "省份", scenic: "景区" };

export const TOUR_TYPES = ["AroundTour", "DomesticTour", "OutboundTour", "OverSeasLocalTour"] as const;
export const PRODUCT_TYPES = ["Retail", "Self"] as const;

export const CTRIP_LOOKUPS_QUERY_KEY = ["ctrip", "lookups"] as const;
export const CTRIP_PROFILE_QUERY_KEY = ["ctrip", "profile"] as const;

export const ctripLookupsApi = {
  summary: () => api<LookupSummary>("/api/v1/ctrip/lookups/summary"),
  list: (kind: LookupKind, status?: LookupStatus) =>
    api<LookupList>(`/api/v1/ctrip/lookups/${kind}${status ? `?status=${status}` : ""}`),
  candidates: (kind: LookupKind, ourId: string, keyword?: string) =>
    api<CandidateResult>(`/api/v1/ctrip/lookups/${kind}/${ourId}/candidates${keyword ? `?keyword=${encodeURIComponent(keyword)}` : ""}`),
  save: (kind: LookupKind, ourId: string, body: { ctrip_id: number } | { not_on_ctrip: true }) =>
    api<LookupSaved>(`/api/v1/ctrip/lookups/${kind}/${ourId}`, { method: "PUT", body: JSON.stringify(body) }),
  getProfile: () => api<CtripProfile>("/api/v1/integrations/platforms/ctrip/profile"),
  putProfile: (body: CtripProfile) =>
    api<CtripProfile>("/api/v1/integrations/platforms/ctrip/profile", { method: "PUT", body: JSON.stringify(body) }),
};
